import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'src/app/services/api.service';
import { BACKEND } from '../../config';

@Component({
  selector: 'app-check-idme',
  templateUrl: './check-idme.component.html',
  styleUrls: ['./check-idme.component.css']
})
export class CheckIdmeComponent implements OnInit {

  response_type: any;
  client_id: any;
  redirect_uri: any;
  state: any;
  verifyURL: string;
  scope: any;

  constructor(
    private router: Router,
    private cookie: CookieService,
    private activatedRoute: ActivatedRoute,
    private _apiService: ApiService) {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params) {
        this.response_type = params['response_type'];
        this.client_id = params['client_id'];
        this.redirect_uri = params['redirect_uri'];
        this.state = params['state'];
        this.scope = params['scope'];
         this.verifyURL = BACKEND + 'oauth/authorize?response_type=' + this.response_type +
          // tslint:disable-next-line:max-line-length
          '&client_id=' + this.client_id + '&redirect_uri=' + this.redirect_uri + '&token=' + this.cookie.get('token') + '&state=' + this.state
          + '&scope=' + this.scope;
        this.verify();
      } else {
      }
    });
  }
  verify() {
    this._apiService.functionPOST('user/getUserDetails', {}).subscribe((response) => {
      if (response['success']) {
        // window.open(this.verifyURL);
 

        document.location.href = BACKEND + 'oauth/authorize?response_type=' + this.response_type +
          '&client_id=' + this.client_id + '&redirect_uri=' + this.redirect_uri + '&token=' +
          this.cookie.get('token') + '&state=' + this.state + '&scope=' + this.scope;

      }
    }
      ,
      err => {
        this.router.navigate([''], { queryParams: { 'url': this.router.url } });
      }
    );
  }
  ngOnInit() {
  }

}
